export const BETA_ANALYTICS_EVENTS = Object.freeze({
  QUIZ_STARTED: "beta.quiz.started",
  QUIZ_COMPLETED: "beta.quiz.completed",
  RECOMMENDATION_GENERATED: "beta.recommendation.generated",
  SHOW_CLICKED: "beta.show.clicked",
  FEEDBACK_SUBMITTED: "beta.feedback.submitted",
  ACCOUNT_CREATED: "beta.account.created",
});

const ALLOWED_PROPERTY_KEYS = new Set([
  "action",
  "authenticated",
  "feedback",
  "identity_type",
  "result_count",
  "restored",
  "show_id",
  "source",
  "surface",
]);

function sanitizeProperties(properties = {}) {
  return Object.entries(properties).reduce((safeProperties, [key, value]) => {
    if (!ALLOWED_PROPERTY_KEYS.has(key)) return safeProperties;
    if (value === undefined || value === null) return safeProperties;
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      safeProperties[key] = value;
    }
    return safeProperties;
  }, {});
}

function getAnalyticsEndpoint() {
  return process.env.REACT_APP_BETA_ANALYTICS_ENDPOINT?.trim() || "";
}

export function trackBetaEvent(eventName, properties = {}) {
  if (!Object.values(BETA_ANALYTICS_EVENTS).includes(eventName)) {
    return null;
  }

  const payload = {
    event: eventName,
    properties: sanitizeProperties(properties),
    timestamp: new Date().toISOString(),
  };

  try {
    window.dispatchEvent(new CustomEvent("hookd:beta-event", { detail: payload }));
  } catch (error) {}

  try {
    window.hookdAnalytics?.track?.(payload.event, payload.properties);
  } catch (error) {}

  const endpoint = getAnalyticsEndpoint();
  if (!endpoint) return payload;

  try {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const sent = navigator.sendBeacon(endpoint, body);
      if (sent) return payload;
    }

    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (error) {}

  return payload;
}
